module.exports = __webpack_public_path__ + "fonts/9fbb736.otf";